import {useEffect, useState} from "react";
import {Swiper, SwiperSlide} from 'swiper/react';
import {Swiper as SwiperInstance} from 'swiper';
import {Mousewheel, Navigation} from 'swiper/modules';
import {ProductInterface} from "../../interfaces/catalog/ProductInterface";
import ChatProductCard from "./ChatProductCard";

import 'swiper/css';
import 'swiper/css/navigation';

export interface CardRef {
    id: number
    href: string
    label: string
}

/**
 * Мини-карточки товаров ответа консультанта лентой с горизонтальной прокруткой: стрелки, свайп,
 * тачпад по горизонтали. Листает сразу видимыми карточками: на десктопе по три. Вертикальное колесо листает чат (forceToAxis).
 */
export default function ChatProductSlider({cards, products, loading, focus = 0}: {
    cards: CardRef[]
    products: Record<number, ProductInterface>
    loading: boolean
    focus?: number // «Показать ещё»: прокрутить к первой добавленной карточке
}) {
    const [swiper, setSwiper] = useState<SwiperInstance | null>(null);

    useEffect(() => {
        if (swiper && !swiper.destroyed) {
            swiper.update();
            swiper.slideTo(focus);
        }
    }, [swiper, focus, cards.length]);

    return <div className="chat-products">
        <Swiper
            onSwiper={setSwiper}
            modules={[Navigation, Mousewheel]}
            navigation
            mousewheel={{forceToAxis: true}}
            spaceBetween={10}
            slidesPerView={1.15}
            breakpoints={{
                576: {slidesPerView: 2.15, slidesPerGroup: 2},
                1200: {slidesPerView: 3, slidesPerGroup: 3},
            }}
        >
            {cards.map(card => <SwiperSlide key={card.id}>
                <ChatProductCard {...card} product={products[card.id]} loading={loading}/>
            </SwiperSlide>)}
        </Swiper>
    </div>;
}
